import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lcon-splx-snmp-ms11',
  templateUrl: './lcon-splx-snmp-ms11.component.html',
  styleUrls: ['./lcon-splx-snmp-ms11.component.css']
})
export class LconSplxSnmpMs11Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
